import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { setHeaderLogoUrl, updateProductMetaData } from "@containers/App/reducer.js"
import { parseResponseData } from "@pages/Corporate/common/BookingSuccess/parser"
import { COMMON_ERROR_CONFIG, LINK_EXPIRED_ERROR_CONFIG } from "../constants"

const initialState = {
    isLoading: false,
    isFetched: false,
    data: null,
    error: null,
}

/**
 * Self Serve lab summary page reducer
 */

export const selfServeBookingSuccessPageSlice = createSlice({
    name: "selfServeBookingSuccessPageReducer",
    initialState: initialState,
    reducers: {
        resetPageData() {
            return { ...initialState }
        },
    },
    extraReducers: (builder) => {
        //handle asynchronous actions
        builder.addCase(fetchPageData.fulfilled, (state, action) => {
            state.isLoading = false
            state.data = parseResponseData(action?.payload)
            state.isFetched = true
            state.error = null
        }),
            builder.addCase(fetchPageData.pending, (state) => {
                state.isLoading = true
                state.data = null
                state.error = null
            }),
            builder.addCase(fetchPageData.rejected, (state, action) => {
                state.isLoading = false
                state.isFetched = true
                state.error = action.payload
                state.data = null
                if (action.payload?.status_code === 410) {
                    state.error = LINK_EXPIRED_ERROR_CONFIG
                } else {
                    state.error = COMMON_ERROR_CONFIG
                }
            })
    },
})

/**
 * fetch page data
 */

export const fetchPageData = createAsyncThunk(
    "selfServeBookingSuccess/fetchData",
    async (_arg, { extra, dispatch, rejectWithValue }) => {
        const { ppmcApi } = extra
        try {
            const res = await ppmcApi.get("v6/self-serve/order")
            if (res?.data?.meta_data) {
                dispatch(
                    updateProductMetaData({
                        title: res.data.meta_data?.title,
                        description: res.data.meta_data?.description,
                    })
                )
                if (res.data.meta_data.logo?.url) {
                    dispatch(setHeaderLogoUrl(res.data?.meta_data?.logo?.url))
                }
            }
            return Promise.resolve(res.data)
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)

export const selfServeBookingSuccessPageReducer = selfServeBookingSuccessPageSlice.reducer

export const { resetPageData } = selfServeBookingSuccessPageSlice.actions
